import ClientDriveContent from "./ClientDriveContent";
import WaypointContent from "./WaypointContent";
import TransportationContent from "./TransportationContent";
import {useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {activateItem, selectActiveItem} from "../../../employee/employeeSlice";
import _ from 'lodash';

const DynamicContentByGeoObject = ({activeOrderId, geoObjects, onWindowExpand, onOpenTransportation}) => {
    const dispatch = useDispatch();
    const activeEmployee = useSelector(selectActiveItem);

    useEffect(() => {
        if (activeOrderId) {
            const elem = document.querySelector('#TransportationContentOrderId_' + activeOrderId);

            elem?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

    }, [activeOrderId]);

    useEffect(() => {
        const firstCourierId = geoObjects[0]?.courierId;

        if (activeEmployee === null && firstCourierId) {
            dispatch(activateItem(firstCourierId))
        } else if (activeEmployee && firstCourierId) {
            const isActiveEmployeeInGeoObjects = _.find(geoObjects, (item) => item.courierId === activeEmployee);

            if (isActiveEmployeeInGeoObjects) {
                dispatch(activateItem(activeEmployee))
            } else {
                dispatch(activateItem(firstCourierId))
            }
        }
    }, [geoObjects]);

    let components = [];
    geoObjects.map((object, key) => {
        if (object.isWayPoint) {
            components.push(<WaypointContent waypoint={object} key={'waypoint-content-' + key}/>);
        } else if (object.isTransportation) {
            components.push(<TransportationContent drive={object}
                                                   onOpenTransportation={(drive) => onOpenTransportation(drive)}
                                                   key={'transportation-content-' + key}/>);
        } else {
            components.push(<ClientDriveContent
                onWindowExpand={(state, geoObject) => onWindowExpand(state, geoObject)}
                drive={object}
                key={'client-drive-content-' + key}/>)
        }
    })
    return components
}

export default DynamicContentByGeoObject